module.exports = __webpack_public_path__ + "static/img/landscape-without-wolves.d1e9f8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/landscape/landscape-without-wolves.jpg
// module id = nVIi
// module chunks = 0